<template>
  <div v-loading="loading" style="background-color:#fff;padding:20px;">
    <el-form ref="form" :model="form" :rules="rules" label-width="140px">
      <el-form-item label="参数名" prop="name">
        <el-input 
          v-model.trim = "form.name" 
          class="h-40 w-300" 
          placeholder="请输入参数名" disabled>
        </el-input>
      </el-form-item>
      <el-form-item label="备注说明" prop="remark">
        <el-input 
          type="textarea" 
          disabled
          :autosize="{minRows: 2, maxRows: 4}" 
          class="w-300" 
          placeholder="请输入备注说明" 
          v-model.trim="form.remark">
        </el-input>
      </el-form-item>
      <div v-if="form.is_serialize === 0">
        <el-form-item label="值" prop="value">
        <el-input
          class="w-300" 
          placeholder="请输入" 
          v-model.trim="form.value">
        </el-input>
      </el-form-item>
      </div>
      <div v-if="form.is_serialize === 1" style="overflow:hidden;">
        <div v-for="(item, index) in form.dimension" :key="item" class="f-l" v-if="item.is_hidden == 0">
          <div class="sub-title" 
            :class="{'m-l-20': true , 'm-b-10': true}">
            {{item.colume_name}}
          </div>
          <!--:class="{'m-l-20':  index > 0}"-->
          <el-form-item class="indentMargin" v-for="(childItem, childIndex, childKey) in form.value" style="margin-right: 35px;">
            <div class="h-40">
              <el-checkbox 
                v-model="childItem[Object.keys(childItem)[index]]"
                :true-label="selectTrue"  
                :false-label="selectFalse"
                v-if='item.type === DICTIONARY_CHECKBOX'>
              </el-checkbox>
              <el-radio-group v-model="childItem[Object.keys(childItem)[index]]" @change="radioChange(childItem, Object.keys(childItem)[index], childIndex)" v-else-if='item.type === DICTIONARY_RADIO'>
                <el-radio 
                  class="radio"  
                  :label="1">&nbsp;</el-radio>
              </el-radio-group>
              <el-input class="h-40 w-100"
                type='number'
                v-else-if='item.type === DICTIONARY_NUMBERTEXT'
                v-model.number="childItem[Object.keys(childItem)[index]]">
              </el-input> 
              <el-input class="h-40 w-100"
                v-else             
                v-model="childItem[Object.keys(childItem)[index]]">
              </el-input>
              <el-button 
                size="small" 
                style="margin-left:20px"
                @click="deleteConfigValue(childIndex)" 
                v-if="index === form.dimension.length - hiddenNum - 1">
                删除
                </el-button>
                <!--:disabled="form.value.length === 1"-->
            </div>
          </el-form-item>
        </div>
        <div style="clear:both;">
          <el-button type="primary" class="w-100" style="margin-left:140px;" @click="addConfigValue()" v-if="form.groups === 20">添加参数</el-button>
        </div>
      </div>
      <el-form-item
        label="参数历史配置"
        style="clear: both;margin-top:20px;">
        <el-select
          class="w-300"
          v-model="logItem">
          <el-option v-for="logItem in form.log"
            :label="logItem.time+'  '+logItem.user"
            :value = "logItem">
          </el-option>
        </el-select>
        <el-button type="primary" :disabled="this.curLogId === null" @click="resetLogConfig">重置历史配置</el-button>
      </el-form-item>
      <el-form-item label=''>
        <el-button type="primary" :loading="isLoading" @click="submitData">提交</el-button>
        <el-button @click="goBack()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>  
</template>
<script>
import http from '../../../../assets/js/http.js'
import cmsConfig from '../../../../config/cmsConfig.js'
export default {
  data() {
    return {
      id: -1, // 列表id
      isLoading: false,
      curLogId: null, // 当前选择历史id
      logItem: null,
      form: {
        name: '',
        remark: '',
        config_key: '',
        config_value: '',
        foreign_key: '',
        is_serialize: 0,
        groups: '',
        log: [],
        dimension: [],
        value: [],
        log_value: ''
      },
      rules: {
        // name: [
        //   { required: true, message: '请输入参数名' }
        // ],
        // remark: [
        //   { required: true, message: '请输入备注说明' }
        // ]
      },
      numValues: [],
      selectTrue: 1,
      selectFalse: 0,
      hiddenNum: 0
    }
  },
  methods: {
    // 获取维度名配置对象
    getConfigModel() {
      let tempObject = {}
      if (this.form.value && this.form.value.length) {  // 如果value不为空，从value的第0个获取字段名
        for (let u in this.form.value[0]) {
          if (_.isNumber(this.form.value[0][u])) {
            tempObject[u] = 0
          } else {
            tempObject[u] = ''
          }
        }
      } else if (this.form.dimension && this.form.dimension.length) {
        this.form.value = []
        let arr = this.form.dimension
        _(arr).forEach((res) => {
          if (res.type === this.DICTIONARY_CHECKBOX || res.type === this.DICTIONARY_RADIO) {
            tempObject[res.key] = 0
          } else {
            tempObject[res.key] = ''
          }
        })
      }

      // else if (this.form.default && this.form.default.length) {
      //   _(this.form.default).forEach((res, key) => {
      //     if (this.form.dimension && this.form.dimension[key]) {  // 否则从维度获取类型
      //       if (this.form.dimension[key].type == 40) {  // 文本类型
      //         tempObject[res] = ''
      //       } else {  // 数字类型
      //         tempObject[res] = 0
      //       }
      //     }
      //   })
      // }
      return tempObject
    },
    // 添加维度名配置值
    addConfigValue() {
      let model = this.getConfigModel()
      this.form.value.push(model)
      // this.updataNumValue(this.form.value)
    },
    // 删除维度名配置值
    deleteConfigValue(index) {
      this.form.value.splice(index, 1)
      this.numValues.splice(index, 1)
    },
    // 更新提取是否为数字的数组
    updataNumValue(data) {
      this.numValues = []
      _(data).forEach((res, index) => {
        this.numValues.push({})
        for (let temp in res) {
          this.numValues[index][temp] = this.vailedTyepe0fNumber(res[temp])
        }
      })
    },
    // 判断是否为数字
    vailedTyepe0fNumber(value) {
      // console.log(value)
      if (_.isNumber(value)) {
        return true
      }
      return false
    },
    // 访问详情接口
    getDataDetail() {
      this.apiGet(`pd/users/${this.id}`).then((res) => {
        if (res.code === 200) {
          // if (res.data.is_serialize === 1) {
          //   if (res.data.value && res.data.value.length > 0) {
          //     this.updataNumValue(res.data.value)
          //   }
          // }
          // 先判断是否序列化，在判断value是否为空，若空，则看维度名中字段是否为空
          // if (res.data.is_serialize === 1) {
          //   if (!res.data.value) {
          //     res.data.value = []
          //     if (res.data.dimension && res.data.dimension.length > 0) {
          //       let value = []
          //       let arr = res.data.dimension
          //       _(arr).forEach((res) => {
          //         let str = {}
          //         _(arr).forEach((res) => {
          //           str[res.key] = ''
          //         })
          //         value.push(str)
          //       })
          //       res.data.value = value
          //     }
          //   }
          // }
          // 若value为空，则以dimension为主-------------------
          // 若value不为空 则dimension数组的长度 和value 对象的长度一定要一致，否则配置未完成
          // 保证配置维度名那边 维度名 key 必填
          // 保持value中的键值和dimension中的key一致
          // res.data.value = [{ aa: 'd1', vv: 1, cc: 1 }]
          if (res.data.is_serialize === 1) {
            let isHandled = false
            if ((res.data.value && res.data.value.length > 0) || (res.data.dimension && res.data.dimension.length > 0)) {
              let value = res.data.value
              let dimension = res.data.dimension
              let value_first = Object.keys(value[0])
              if (value_first.length === dimension.length) {
                // 判断元素是否一致
                // 一致，什么都不处理
                // 不一致
                let is_same = true
                _(dimension).forEach((res, index) => {
                  if (res.key !== value_first[index]) {
                    is_same = false
                  }
                })
                if (!is_same) {
                  _(value).forEach((res, index) => {
                    let i = 0
                    let temp = {}
                    for (let key in res) {
                      temp[dimension[i].key] = 0
                      i++
                    }
                    value[index] = temp
                  })
                }
                res.data.value = value
                isHandled = true
              }
            }
            if (!isHandled) {
              _g.toastMsg(this, 'error', '配置未完成')
              this.goBack()
              return
            }
          }
          this.form = res.data
          _(this.form.dimension).forEach((item) => {
            if (item.is_hidden != 0) {
              this.hiddenNum++
            }
          })
          return
        }
        this.goBack()
      })
    },
    // 重置历史纪录配置
    resetLogConfig() {
      this.loading = true
      if (this.curLogId) {
        let postData = {
          id: this.curLogId
        }
        this.apiPost(`pd/users/getLogConfig`, postData).then((res) => {
          if (res.code === 200) {
            // if (res.data.is_serialize === 1) {
            //   if (res.data.value && res.data.value.length > 0) {
            //     this.updataNumValue(res.data.value)
            //   }
            // }
            this.form = res.data
            // this.resetData()
            this.logItem = this.logItem.time + '  ' + this.logItem.user
          }
          this.loading = false
        })
      }
    },
    // 获取历史数据后重置部分数据
    resetData() {
      this.logItem = null
      this.curLogId = null
    },
    // 表单校验
    validateForm() {
      let validated = true
      this.$refs.form.validate((res) => {
        if (!res) {
          validated = false
        }
      })
      if (!validated) {
        _g.toastMsg(this, 'error', '请检查信息是否输入完整')
      }
      return validated
    },
    // 单选框变化
    radioChange(item, key, childIndex) {
      if (item[key] == 0) {
        return
      }
      _(this.form.value).forEach((res, index) => {
        if (res[key] == 1 && index != childIndex) {
          res[key] = 0
        }
      })
    },
    // 提交数据
    submitData() {
      this.isLoading = true
      // 校验表单
      if (!this.validateForm()) {
        this.isLoading = false
        return
      }
      // 访问编辑接口
      let putData = _.cloneDeep(this.form)
      delete putData.id
      this.apiPut(`pd/users/`, this.id, putData).then((res) => {
        this.isLoading = false
        if (res.code === 200) {
          _g.toastMsg(this, 'success', res.data)
          this.goBack()
        } else {
          _g.toastMsg(this, 'error', res.error)
        }
      })
    },
    // 返回上层
    goBack() {
      router.go(-1)
    }
  },
  watch: {
    logItem() {
      this.form.log_value = this.logItem.time + '  ' + this.logItem.user
      this.curLogId = this.logItem.id
    }
  },
  created() {
    // 获取所选列表ID
    this.id = this.$route.params.id
    // 访问详情接口更新数据
    this.getDataDetail()
  },
  mixins: [http, cmsConfig]
}
</script>
<style>
  .f-l {
    float: left;
  }
  .m-l-140 {
    margin-left: 140px;
  }
  .m-b-10 {
    margin-bottom: 10px;
  }
</style>




// WEBPACK FOOTER //
// edit.vue?87f7dacc